import { render, staticRenderFns } from "./AttachmentSingle.vue?vue&type=template&id=7e008c5e&"
import script from "./AttachmentSingle.vue?vue&type=script&lang=js&"
export * from "./AttachmentSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports